import { BaseMarker } from './baseMarker'

abstract class BaseMarkerRenderer<MarkerType extends BaseMarker<any, any, any, any>> {
  marker: MarkerType
  constructor(marker: MarkerType) {
    this.marker = marker
  }

  /**
   * Draw marker onto canvas
   */
  abstract renderMarker(): void

  /**
   * Draw markers handles onto canvas
   */
  renderHandles() {
    if (this.marker.state.isShowHandles === true) this.marker.state.handles.forEach((handle) => handle.render())
  }

  /**
   * Call all subsequent rendering functions for the marker
   */
  render() {
    this.renderMarker()
    this.renderHandles()
  }
}

export { BaseMarkerRenderer }
